/* eslint-disable */
import axios from '../request/http.js'; // 导入http中创建的axios实例
import VueCookies from 'vue-cookies'


// 测试环境
// const url = "https://your_domain.com";
// const base = "https://your_domain.com";
const url = "https://yueshangpeiyin.com:8052";
const base = "https://yueshangpeiyin.com:8052";
// const base = "https://yueshangpeiyin.com:8054";
// const url = "https://yueshangpeiyin.com:8054";
// const base = "https://localhost:8052";
// const url = "https://localhost:8052";
const  basenew= "https://yueshangpeiyin.com:8053";
// 正式环境
//  const url = "https://moyin-gateway.moyin.com/moyin-real-voice-speaker";
//  const base = "https://moyin-gateway.moyin.com/moyin-real-voice-speaker";
// 微信公众号appid
const appid = "wxea4ae255733cb575";
// h5支付页面回调地址
const h5 = "https://voice-maker-mobile.mobvoi.com/real-voice/#/WXLOGINX/";
// 主站的url
const moweb = "https://www.moyin.com/";
// 主站访问接口地址地址
const mourl = "https://www.moyin.com/";
const Api = {
  h5:h5,
  appid:appid,
  moweb:moweb,
  systemBase() {
    return base
  },
  systemUrl() {
    return url
  },
  signIn (username,password) 
  { 
    // return axios.post(`http://123.56.162.251:8053/admin/login/status`, {username,password})
    return this.postDataNew(`/admin/login/status`, {username,password})
  },
  signUp (registerForm) 
  { 
    // return axios.post(`http://123.56.162.251:8053/admin/signup`, registerForm)
    return this.postDataNew(`/admin/signup`, registerForm)
  },
  List () 
  { 
    return axios.post(`http://lcoalhost:8053/introduce/list`, registerForm)
  },
  //post请求
  postData(url, data) {
    if(VueCookies.get('root_ww_token')){
      data.token = VueCookies.get('root_ww_token');
    }
    return axios.post(`${base}${url}`, data, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }, 
   //post请求
   postDataNew(url, data) {
     
    return axios.post(`${basenew}${url}`, data, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  },  
  //获取配置
   getData(url) {
    let token = "";
     if(VueCookies.get('root_ww_token')){
       token = VueCookies.get('root_ww_token');
     }
    return axios.get(`${base}${url}`,{params:{token:token}});
  },    //获取配置
   getMoyin(url,data) {
    return axios.get(`${mourl}${url}`,{params:data});
  },
  islogin() {
    if(VueCookies.get('root_ww_token')){
      return true;
    }else{
      return false;
    }
  },
}

export default Api;



// WEBPACK FOOTER //
// ./src/api/api.js